/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAuthUserFromJSON, ApiAuthUserToJSON, } from './ApiAuthUser';
export function InlineObject11FromJSON(json) {
    return InlineObject11FromJSONTyped(json, false);
}
export function InlineObject11FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'user': !exists(json, 'user') ? undefined : ApiAuthUserFromJSON(json['user']),
    };
}
export function InlineObject11ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user': ApiAuthUserToJSON(value.user),
    };
}
